module.exports = __webpack_public_path__ + "assets/img/right.5a18afd9.svg";